import { render, staticRenderFns } from "./BchatArea.vue?vue&type=template&id=c9eeb694&scoped=true"
import script from "./BchatArea.vue?vue&type=script&lang=js"
export * from "./BchatArea.vue?vue&type=script&lang=js"
import style0 from "./BchatArea.vue?vue&type=style&index=0&id=c9eeb694&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9eeb694",
  null
  
)

export default component.exports